import React, { useContext, useEffect, useState, useRef } from "react";
import FormDataContext from "../../../Contexts/FormData.context";
import { formActionEnum, jsonKeyMapping } from "../../../Config/Constants";
import { TemplateObject } from "../../../Models/TemplateObject";
import InputWrapper from "./InputWrapper";
import InputContext from "../../../Contexts/Input.Context";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { FaRegCalendarAlt } from "react-icons/fa";

interface Props {
  formElement: TemplateObject;
  handleDateChange: (id: string, type: string, date: any) => void;
}

const InputDate: React.FC<Props> = ({ formElement, handleDateChange }) => {
  const { state, dispatch } = useContext(FormDataContext);
  const { setConditionalInput } = useContext(InputContext);
  const { formData } = state;
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    if (formElement && formElement[jsonKeyMapping.FORM_DATE_FORMAT]) {
      const formElementData = {
        [`meta-data-${formElement[jsonKeyMapping.FORM_ID]}`]: {
          timeFormat: formElement[jsonKeyMapping.FORM_DATE_FORMAT],
        },
      };

      dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData });
    }
  }, [formElement]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const loadDateFields = (date: Date) => {
    if (date && formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS] !== undefined) {
      setConditionalInput({
        formElement: formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS],
        parentLabel: formElement[jsonKeyMapping.FORM_LABEL],
        value: formElement[jsonKeyMapping.FORM_VALUE],
      });
    } else {
      setConditionalInput(null);
    }

    const formattedDate = date ? moment(date).format("MM-DD-YYYY") : null;
    setOpen(false);
    handleDateChange(formElement[jsonKeyMapping.FORM_ID], "date", formattedDate);
  };

  return (
    <InputWrapper
      formElement={formElement}
      label={formElement[jsonKeyMapping.FORM_LABEL] || ""}
      labelsub={formElement[jsonKeyMapping.FORM_LABEL_SUB] || ""}
      subtext={formElement[jsonKeyMapping.FORM_SUBTEXT] || ""}
    >
      <div style={{ position: "relative" }} ref={datePickerRef}>
        <DatePicker
          // selected={selectedDate}
          onChange={loadDateFields}
          open={open}
          dateFormat={formElement[jsonKeyMapping.FORM_DATE_FORMAT]}
          minDate={formElement.min ? new Date(formElement.min) : null}
          maxDate={formElement.max ? new Date(formElement.max) : null}
          className={`form-control ${formElement.inputClass ? formElement.inputClass : ""}`}
          id={formElement[jsonKeyMapping.FORM_ID]}
          value={formData[formElement[jsonKeyMapping.FORM_ID]]}
          onInputClick={() => setOpen((prev) => !prev)}
          placeholderText="Select a date"
          peekNextMonth={true}
          showMonthDropdown={true}
          showYearDropdown={true}
          dropdownMode="select"
        />
        <FaRegCalendarAlt
          onClick={() => setOpen((prev) => !prev)}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "auto",
            cursor: "pointer",
            color: "#999",
            fontSize: "20px",
          }}
        />
      </div>
    </InputWrapper>
  );
};

export default InputDate;
